import {getField, updateField} from "vuex-map-fields";

const state = () => ({
    showConversationDialog: false,
    showBotPicker: false,
    showDialogBlockCustomer: false,
    showDialogCreateMADTemplate: false,
    dialogUpdateMADTemplate: {
        open: false,
        template: {}
    },
    showDialogMADTemplate: false,
    showDialogCreateQuickResponse: false,
    dialogConversationHistory: {},
});
const mutations = {
    toggleConversationDialog(state) {
        state.showConversationDialog = !state.showConversationDialog
    },
    toggleBotPicker(state) {
        state.showBotPicker = !state.showBotPicker
    },
    setDialogBlockCustomer(state, payload) {
        state.showDialogBlockCustomer = payload
    },
    setDialogCreateQuickResponse(state, payload) {
        state.showDialogCreateQuickResponse = payload
    },
    setDialogConversationHistory (state, payload) {
        state.dialogConversationHistory = payload
    },
    setDialogCreateMADTemplate (state, payload) {
        state.showDialogCreateMADTemplate = payload
    },
    setDialogUpdateMADTemplate (state, payload) {
        state.dialogUpdateMADTemplate = payload
    },
    setDialogMADTemplate(state, payload) {
        state.showDialogMADTemplate = payload
    },
    updateField
};
const actions = {
    openConversationHistoryBySession(context, {sessionId, user, updated}) {
        context.commit('toggleConversationDialog');
        context.commit('setDialogConversationHistory', {sessionId: sessionId, user: user, updated: updated})
    },
    openConversationHistoryByChatLog(context, chatLogs) {
        context.commit('toggleConversationDialog');
        context.commit('setDialogConversationHistory', {chatLogs: chatLogs})
    },
    openDialogBlockCustomer(context) {
        context.commit('setDialogBlockCustomer', true);
    },
    closeDialogBlockCustomer(context) {
        context.commit('setDialogBlockCustomer', false);
    },
    openDialogMADTemplate(context) {
      context.commit('setDialogMADTemplate', true)
    },
    closeDialogMADTemplate(context) {
      context.commit('setDialogMADTemplate', false)
    },
    openDialogCreateMADTemplate(context) {
        context.commit('setDialogCreateMADTemplate', true);
    },
    closeDialogCreateMADTemplate(context) {
        context.commit('setDialogCreateMADTemplate', false);
    },
    openDialogUpdateMADTemplate(context, data) {
        context.commit('setDialogUpdateMADTemplate', {open: true, template: data});
    },
    closeDialogUpdateMADTemplate(context) {
        context.commit('setDialogUpdateMADTemplate', {open: false, template: {}});
    },
    openDialogCreateQuickResponse(context) {
        context.commit("setDialogCreateQuickResponse", true);
    },
    openDialogCreateQuickResponseLeader(context) {
        context.commit("setDialogCreateQuickResponse", true);
        context.commit("agentQuickResponse/setType", 1, {root: true});
    },
    openDialogUpdateQuickResponse({ commit, dispatch }, data) {
        dispatch('agentQuickResponse/bindUpdateForm', data, { root: true })
        commit("setDialogCreateQuickResponse", true)
    },
    closeDialogCreateQuickResponse(context) {
        context.commit("setDialogCreateQuickResponse", false);
        context.commit("agentQuickResponse/setType", 0, {root: true});
    }

};
const getters = {getField};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
